module.exports = __webpack_public_path__ + "static/media/handoff-start-m.0278e739.png";